import { CONFIG } from '../config/constants.js';
import { determineEnding } from './endingSystem.js';

/**
 * Checks if player has won
 * @param {number} day - Current game day
 * @param {Array} remainingWorkers - Workers still alive
 * @returns {boolean} True if won
 */
export function checkVictory(day, remainingWorkers) {
  return day >= CONFIG.WIN_DAY && remainingWorkers.length > 0;
}

/**
 * Checks if player has lost
 * @param {Array} remainingWorkers - Workers still alive
 * @returns {boolean} True if lost
 */
export function checkDefeat(remainingWorkers) {
  return remainingWorkers.length === 0;
}

/**
 * Gets victory/defeat message (legacy function, use determineEnding instead)
 * @param {boolean} won - Whether player won
 * @param {number} day - Current day
 * @returns {Object} Message object with title, icon, and message
 * @deprecated Use determineEnding from endingSystem.js instead
 */
export function getEndGameMessage(won, day) {
  if (won) {
    return {
      title: 'Victory!',
      icon: '🏆',
      message: `You survived ${day} days! Your settlement thrives!`
    };
  } else {
    return {
      title: 'Defeat',
      icon: '💀',
      message: `Your settlement fell on day ${day}. The wilderness claims another...`
    };
  }
}

/**
 * Determines the game ending based on state
 * This is the new primary victory/defeat checking function
 * @param {Object} gameState - Complete game state
 * @returns {Object|null} Ending object or null if not ended
 */
export function checkGameEnding(gameState) {
  return determineEnding(gameState);
}
